const A = window.WALL_LP_ASSETS || {};
/* ---- script block 0 ---- */
(() => {
  const hero = document.getElementById('hero-section'); // class="p-mv" を持つ要素

  if (!hero) return;

  // Step 1: ヒーロー登場（背景画像・タイトルのフェードイン）— 1.2秒後に開始
  setTimeout(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        hero.classList.add('is-hero-visible');
      });
    });
  }, 1200);

  // Step 2: INFORMATIONカード登場（ヒーロー開始から1000ms後）
  setTimeout(() => {
    document.body.classList.add('is-entered');
  }, 2200);
})();

/* ---- script block 1 ---- */
(() => {
  const WIDTH_SP = 768;

  const triggerFadeIn = (elem) => {
    // .js-hero-fade は CSS側で固定値（1.2s delay / 1.2s duration、
    // ヒーローセクションの .p-mv__header と同じ演出）を指定しているため、
    // ここでインラインstyleを上書きせず、CSSの値をそのまま使わせる。
    if (!elem.classList.contains('js-hero-fade')) {
      const delay = parseFloat(elem.dataset.delay) || 0;
      const duration = parseFloat(elem.dataset.duration) || 1.5;
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
    elem.classList.add('js-scroll-in');
  };

  const elems = document.querySelectorAll('.js-fade-in, .js-hero-fade');
  if (!elems.length) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          triggerFadeIn(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.2,
    });

    elems.forEach((elem) => observer.observe(elem));
  } else {
    // フォールバック：スクロール位置から判定
    const checkFadeIn = () => {
      elems.forEach((elem) => {
        if (elem.classList.contains('js-scroll-in')) return;
        const rect = elem.getBoundingClientRect().top;
        const scroll = window.pageYOffset || document.documentElement.scrollTop;
        const offset = rect + scroll;
        const windowHeight = window.innerHeight;
        const position = document.body.clientWidth > WIDTH_SP ? 200 : 0;
        const dispPosition = offset - windowHeight + position;
        if (scroll > dispPosition) triggerFadeIn(elem);
      });
    };
    checkFadeIn();
    window.addEventListener('scroll', checkFadeIn, { passive: true });
    window.addEventListener('resize', checkFadeIn);
  }
})();

/* ---- script block 2 ---- */
(() => {
  const slider = document.getElementById('move-text-slider');
  if (!slider) return;

  const texts = slider.querySelectorAll('.move-text');
  if (!texts.length) return;

  let current = 0;
  const INITIAL_DELAY_MS = 2500; // 表示が始まるまでの待ち時間
  const INTERVAL_MS = 5500; // ゆっくり・安らぎ感のある切替間隔

  // 2.5秒後にテキスト1（最初のブロック）をフェードイン表示
  setTimeout(() => {
    texts[current].classList.add('is-active');

    // テキストが2つ以上ある場合のみ、その後ループ切り替えを開始
    if (texts.length > 1) {
      setInterval(() => {
        const next = (current + 1) % texts.length;
        texts[current].classList.remove('is-active');
        texts[next].classList.add('is-active');
        current = next;
      }, INTERVAL_MS);
    }
  }, INITIAL_DELAY_MS);
})();

/* ---- script block 3 ---- */
(() => {
  const track = document.getElementById('fiveWallTrack');
  if (!track) return;

  const slides = Array.from(track.children);
  const halfCount = slides.length / 2; // 2セット分用意しているので、半分が1ループ分

  const getSlideStep = () => {
    // 1枚分の幅（画像幅＋左右マージン）を計算
    const first = slides[0];
    const rect = first.getBoundingClientRect();
    const style = getComputedStyle(first);
    const marginLeft = parseFloat(style.marginLeft) || 0;
    const marginRight = parseFloat(style.marginRight) || 0;
    return rect.width + marginLeft + marginRight;
  };

  const getLoopWidth = () => getSlideStep() * halfCount;

  let position = 0;
  let speed = 0.5; // 1フレームあたりの移動px（小さいほどゆっくり）
  let paused = false;
  let rafId = null;

  const tick = () => {
    if (!paused) {
      position += speed;
      const loopWidth = getLoopWidth();
      if (loopWidth > 0 && position >= loopWidth) {
        position -= loopWidth; // 1セット分流れたら、継ぎ目なく先頭に戻す
      }
      track.style.transform = `translateX(${-position}px)`;
    }
    rafId = window.requestAnimationFrame(tick);
  };

  track.addEventListener('mouseenter', () => { paused = true; });
  track.addEventListener('mouseleave', () => { paused = false; });

  rafId = window.requestAnimationFrame(tick);

  window.addEventListener('beforeunload', () => {
    if (rafId) window.cancelAnimationFrame(rafId);
  });
})();

/* ---- script block 5 ---- */
(() => {
  const sectionIds = ['product-statement-section'];

  sectionIds.forEach((id) => {
    const section = document.getElementById(id);
    if (!section) return;

    const fadeEls = Array.from(section.querySelectorAll('.our-vision__fade'));
    if (!fadeEls.length) return;

    let started = false;
    const startSequence = () => {
      if (started) return;
      started = true;
      fadeEls.forEach((el) => {
        const delay = parseInt(el.dataset.visionDelay, 10) || 0;
        setTimeout(() => {
          el.classList.add('js-scroll-in');
        }, delay);
      });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startSequence();
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      observer.observe(section);
    } else {
      startSequence();
    }
  });
})();

/* ---- script block 6 ---- */
const IMGS = {
  "hero":A["js-hero"]
}
IMGS["vid_height"]=A["js-vid-height"];
IMGS["vid_silent"]=A["js-vid-silent"];
IMGS["panel_img"]=A["js-panel"];
IMGS["cord_img"]=A["js-cord"];
IMGS["slope_img"]=A["js-slope"];
IMGS["size2"]=A["js-size2"];
IMGS["color2"]=A["js-color2"];
if (window.matchMedia('(max-width: 768px)').matches) {
  IMGS["panel_img"]=A["js-panel-sp"];
  IMGS["cord_img"]=A["js-cord-sp"];
  IMGS["slope_img"]=A["js-slope-sp"];
  IMGS["size2"]=A["js-size2-sp"];
  IMGS["color2"]=A["js-color2-sp"];
}
const HERO_IMG = IMGS['hero'];
const PANELS = [
  {nav:'サイズ',icon:'plus',title:'サイズ。',body:'LX1/ST1は、幅120cm・140cmの2サイズ展開。奥行き60cmで、手前のパソコンにも奥のモニターにも届きやすく、横長のスペースがデスクをすっきり整えます。高さは70〜112cmまで電動昇降できます。',img:'size2'},
  {nav:'カラー',icon:'swatch',swatchColor:'#6b6b70',title:'カラー。',body:'PaleBeigeとCharcoalGrayの2色展開。明るく軽やかな空間にはペールベージュ、パソコン機器や落ち着いたインテリアにはチャコールグレーが自然になじみます。',img:'color2'},
  {nav:'高さ調整',icon:'plus',title:'高さ調整/耐荷重。',body:'70〜112cmまで高さ調節可能。座る、立つ、身長や作業姿勢に合わせて、使いやすい高さへ静かに調整できます。耐荷重も80kgの設計により、安定感のある使い心地を保ちます。',img:'vid_height',video:true,stats:true},
  {nav:'静音設計',icon:'plus',title:'静音設計。',body:'静音設計により、昇降時の動きはなめらかで安定。水の入ったカップも大きく揺れにくく、作業中でも音や振動が気になりにくい設計です。',img:'vid_silent',video:true},
  {nav:'安全性/操作性',icon:'plus',title:'安全性/操作性。',body:'障害物検知機能を標準装備し、安全な昇降をサポート。操作しやすいコントロールパネルで高さの調整だけでなく、3点の高さの登録が可能。USB・Type-Cポートも搭載。',img:'panel_img'},
  {nav:'コードマネージメント',icon:'plus',title:'コードマネージメント。',body:'天板カバーを開けるだけで電源タップや余分なコードを収納可能。左右対応のコードスリット、背面スリット、さらに引き出しを備え、配線も小物も美しくすっきり整えます。',img:'cord_img'},
  {nav:'スロープエッジ',icon:'plus',title:'スロープエッジ。',body:'天板の手前にゆるやかな傾斜をつけたスロープエッジ設計。手首や腕が自然になじみ、タイピングやマウス操作時の負担を軽減。長時間の作業も、より快適に続けられます。',img:'slope_img'},
];
const PLUS_SVG='<svg viewBox="0 0 12 12"><line x1="6" y1="1" x2="6" y2="11"/><line x1="1" y1="6" x2="11" y2="6"/></svg>';

let cur=-1,isHero=true;
const $=id=>document.getElementById(id);
const pvStage=$('pvStage'),pvPillList=$('pvPillList'),
      pvClose=$('pvClose'),pvArrows=$('pvArrows'),
      arrowUp=$('arrowUp'),arrowDn=$('arrowDn');

/* ---- Preload: 画像を永続参照で保持しGC防止 ---- */
const _preloadCache=[];
PANELS.forEach(p=>{
  if(!p.video){
    const i=new Image();i.src=IMGS[p.img];
    _preloadCache.push(i);
  }
});
const heroPreload=new Image();heroPreload.src=HERO_IMG;
_preloadCache.push(heroPreload);

const initImg=document.createElement('img');
initImg.src=HERO_IMG;initImg.style.opacity='1';
pvStage.appendChild(initImg);

arrowUp.addEventListener('click',()=>{if(cur>0)goTo(cur-1)});
arrowDn.addEventListener('click',()=>{if(cur<PANELS.length-1)goTo(cur+1)});
pvClose.addEventListener('click',()=>resetToHero());

/* ---- crossfade: ロード完了を待ってからフェードイン ---- */
let _cfGen=0; /* 世代カウンタ: 連続切替時に古いクリーンアップが新コンテンツを消すのを防ぐ */

function crossfade(src,isVideo){
  const gen=++_cfGen;
  let n;

  const doFade=()=>{
    if(n._faded) return;
    n._faded=true;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      n.style.opacity='1';
      setTimeout(()=>{
        /* 最新の世代のときだけ古い要素を削除 */
        if(gen===_cfGen){
          [...pvStage.querySelectorAll('img,video')].forEach(e=>{if(e!==n)e.remove()});
        }
      },900);
    }));
  };

  if(isVideo){
    n=document.createElement('video');
    n.autoplay=true;n.loop=true;n.muted=true;n.playsInline=true;
    n.preload='auto';
    n.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .8s ease;';
    pvStage.appendChild(n);
    n.addEventListener('canplay',doFade,{once:true});
    n.addEventListener('loadeddata',doFade,{once:true});
    n.src=src;
    n.load();
    setTimeout(doFade,3000);
  } else {
    n=document.createElement('img');
    n.style.opacity='0';
    pvStage.appendChild(n);
    n.onload=doFade;
    n.onerror=doFade;
    n.src=src;
    if(n.complete && n.naturalWidth>0) doFade();
    setTimeout(doFade,3000);
  }
}

function renderHeroPills(){
  pvPillList.innerHTML='';
  PANELS.forEach((p,i)=>{
    const b=document.createElement('button');b.className='pv-pill';
    b.innerHTML=(p.icon==='swatch'
      ?'<div class="pv-pill-swatch" style="background:'+p.swatchColor+'"></div>'
      :'<div class="pv-pill-icon">'+PLUS_SVG+'</div>')+p.nav;
    b.addEventListener('click',()=>goTo(i));
    pvPillList.appendChild(b);
  });
}

function renderDetailPills(a){
  pvPillList.innerHTML='';
  PANELS.forEach((p,i)=>{
    if(i===a){
      const d=document.createElement('div');d.className='pv-desc-card';
      d.innerHTML='<div class="pv-desc-title">'+p.title+'</div><div class="pv-desc-body">'+p.body+'</div>';
      pvPillList.appendChild(d);
    } else {
      const b=document.createElement('button');b.className='pv-pill';
      b.innerHTML=(p.icon==='swatch'
        ?'<div class="pv-pill-swatch" style="background:'+p.swatchColor+'"></div>'
        :'<div class="pv-pill-icon">'+PLUS_SVG+'</div>')+p.nav;
      b.addEventListener('click',()=>goTo(i));
      pvPillList.appendChild(b);
    }
  });
  arrowUp.classList.toggle('disabled',a<=0);
  arrowDn.classList.toggle('disabled',a>=PANELS.length-1);

  /* ---- モバイル：項目一覧→説明文へ排他切替 ---- */
  const pvLeft=document.getElementById('pvLeft');
  const mdTitle=document.getElementById('pvMobileDescTitle');
  const mdBody=document.getElementById('pvMobileDescBody');
  if(pvLeft && mdTitle && mdBody){
    mdTitle.textContent=PANELS[a].title;
    mdBody.textContent=PANELS[a].body;
    pvLeft.classList.add('is-detail-mode');
    if(window.syncPvMobileStats){
      requestAnimationFrame(()=>requestAnimationFrame(window.syncPvMobileStats));
    }
  }
}

function resetToHero(){
  isHero=true;cur=-1;
  pvClose.classList.remove('show');
  pvArrows.classList.remove('show');
  document.getElementById('pvTitleOverlay').classList.remove('hidden');
  const pvLeft=document.getElementById('pvLeft');
  if(pvLeft) pvLeft.classList.remove('is-detail-mode');
  renderHeroPills();
  crossfade(HERO_IMG,false);
}

function enterDetail(){
  isHero=false;
  pvClose.classList.add('show');
  pvArrows.classList.add('show');
  document.getElementById('pvTitleOverlay').classList.add('hidden');
}

function goTo(idx){
  if(idx<0||idx>=PANELS.length||idx===cur)return;
  if(isHero)enterDetail();
  cur=idx;
  /* ステージ内の要素が4つ以上溜まっていたら古い方から削除（蓄積防止） */
  const stageEls=[...pvStage.querySelectorAll('img,video')];
  if(stageEls.length>=4){
    stageEls.slice(0,-2).forEach(e=>e.remove());
  }
  crossfade(IMGS[PANELS[idx].img],PANELS[idx].video);
  renderDetailPills(idx);
}

renderHeroPills();

/* ---- モバイル：「項目一覧へ戻る」ボタン ---- */
const pvMobileDescBack=document.getElementById('pvMobileDescBack');
if(pvMobileDescBack){
  pvMobileDescBack.addEventListener('click',()=>{
    const pvLeftEl=document.getElementById('pvLeft');
    if(pvLeftEl) pvLeftEl.classList.remove('is-detail-mode');
    if(window.syncPvMobileStats){
      requestAnimationFrame(()=>requestAnimationFrame(window.syncPvMobileStats));
    }
  });
}

// ── Stat counter animation (looping) ──
const pvStats=document.getElementById('pvStats');
const statCm=document.getElementById('statCm');
const statKg=document.getElementById('statKg');
let statLoopTimer=null;
let statActive=false;

function animateCounter(el,from,to,duration){
  return new Promise(resolve=>{
    const start=performance.now();
    function tick(now){
      const p=Math.min((now-start)/duration,1);
      const ease=1-Math.pow(1-p,3);
      el.textContent=Math.round(from+(to-from)*ease);
      if(p<1) requestAnimationFrame(tick);
      else resolve();
    }
    requestAnimationFrame(tick);
  });
}

function runStatLoop(){
  if(!statActive)return;
  statCm.textContent='70';
  statKg.textContent='0';
  setTimeout(()=>{
    if(!statActive)return;
    Promise.all([
      animateCounter(statCm,70,112,1200),
      animateCounter(statKg,0,80,1400)
    ]).then(()=>{
    if(!statActive)return;
    statLoopTimer=setTimeout(()=>{
      if(statActive) runStatLoop();
    },3000);
  });
  },1000);
}

function showStats(){
  pvStats.classList.add('show');
  statActive=true;
  clearTimeout(statLoopTimer);
  setTimeout(()=>runStatLoop(),400);
}

function hideStats(){
  statActive=false;
  clearTimeout(statLoopTimer);
  pvStats.classList.remove('show');
  statCm.textContent='70';
  statKg.textContent='0';
}

// Patch goTo to handle stats
const _origGoTo=goTo;
goTo=function(idx){
  _origGoTo(idx);
  if(idx>=0&&PANELS[idx].stats){
    showStats();
  } else {
    hideStats();
  }
};

// Patch resetToHero to hide stats
const _origReset=resetToHero;
resetToHero=function(){
  _origReset();
  hideStats();
};



/* ---- script block 7 ---- */
(function(){
  const lines = document.querySelectorAll('.manifesto-line');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const idx = Array.from(lines).indexOf(el);
        setTimeout(() => {
          el.classList.add('visible');
        }, idx * 250);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.15 });
  
  lines.forEach(line => observer.observe(line));
})();

/* ---- script block 8 ---- */
(function(){
  const fades = document.querySelectorAll('.arex-fade');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const allFades = Array.from(fades);
        const idx = allFades.indexOf(el);
        setTimeout(() => {
          el.classList.add('visible');
        }, idx * 300);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  fades.forEach(el => observer.observe(el));
})();

/* ---- script block 9 ---- */
(function(){
  const el = document.querySelector('.overview-fade');
  if(!el) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if(e.isIntersecting){
        el.classList.add('visible');
        obs.unobserve(el);
      }
    });
  }, {threshold:0.15});
  obs.observe(el);
})();

/* ---- script block: PRODUCTS INTRODUCTION swatch switching ---- */
(() => {
  const IMGS = {
    lx1: A["product-lx1"],
    st1: A["product-st1"],
  };
  const mainImg = document.getElementById('piMainImg');
  const swatches = document.querySelectorAll('.products-intro__swatch');
  if (!mainImg || !swatches.length) return;

  swatches.forEach(btn => {
    btn.addEventListener('click', () => {
      const model = btn.dataset.piModel;
      if (!IMGS[model]) return;
      swatches.forEach(s => s.classList.remove('is-active'));
      btn.classList.add('is-active');
      mainImg.src = IMGS[model];
      mainImg.alt = 'WALL 電動昇降デスク ' + model.toUpperCase();
    });
  });
})();

/* ---- script block: PRODUCT LINEUP modal ---- */
(() => {
  const modal = document.getElementById('product-lineup-modal');
  if (!modal) return;
  const overlay = modal.querySelector('.lineup-modal__overlay');
  const closeBtn = modal.querySelector('.lineup-modal__close');
  const compareBtns = document.querySelectorAll('#piCompareBtn, .js-open-compare-modal');

  const openModal = (e) => {
    if (e) e.preventDefault();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeModal = () => {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  compareBtns.forEach(btn => btn.addEventListener('click', openModal));
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (overlay) overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();

/* ---- script block: RECOMMEND SECTION 画像オートズーム ---- */
/* equals.tokyo（WALL SMART WORK SOLUTION LP）の .zoom-image と同じ
   scale 8s cubic-bezier(0.25,0.46,0.45,0.94) を採用。
   画面内に入ったタイミングで一度だけゆっくりズームし、途中（scale:1.12）で止まる。 */
(() => {
  const imgs = document.querySelectorAll('.recommend__img img');
  if (!imgs.length) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-zoomed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    imgs.forEach(img => observer.observe(img));
  } else {
    imgs.forEach(img => img.classList.add('is-zoomed'));
  }
})();

/* ---- FAQ accordion (cofochair.jp準拠: max-height toggle) ---- */
(() => {
  const toggles = document.querySelectorAll('.js-faq-toggle');
  if (!toggles.length) return;

  toggles.forEach(dt => {
    dt.addEventListener('click', () => {
      const dd = dt.nextElementSibling;
      if (!dd) return;

      const isOpen = dt.classList.contains('is-on');

      if (isOpen) {
        dd.style.maxHeight = '0';
        dt.classList.remove('is-on');
      } else {
        dd.style.maxHeight = dd.scrollHeight + 'px';
        dt.classList.add('is-on');
      }
    });
  });
})();

/* ---- script block: GALLERY SLIDER ---- */
(() => {
  const TOTAL = 9;
  const track = document.getElementById('gallery-track');
  if (!track) return;

  const nums = Array.from(document.querySelectorAll('.contents-num'));
  let current = 0;

  nums.forEach((n, i) => {
    n.addEventListener('click', () => goTo(i));
  });

  // init: show first slide with delay so cloud fade-in is visible
  const firstSlide = track.querySelectorAll('.slide')[0];
  if (firstSlide) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        firstSlide.classList.add('slide-visible');
      });
    });
  }

  function goTo(idx) {
    if (idx >= TOTAL) idx = 0;
    if (idx < 0) idx = TOTAL - 1;
    current = idx;
    const vw = document.querySelector('.slider-outer').offsetWidth;
    track.style.transform = 'translateX(' + (-current * vw) + 'px)';
    nums.forEach((n, i) => n.classList.toggle('active', i === current));

    // fade in the incoming slide
    const slides = track.querySelectorAll('.slide');
    const target = slides[current];
    if (target) {
      target.classList.remove('slide-visible');
      void target.offsetWidth;
      requestAnimationFrame(() => {
        target.classList.add('slide-visible');
      });
    }
  }

  // Mouse drag
  let startX = 0, isDragging = false, dragStartTime = 0;
  track.addEventListener('mousedown', function(e) {
    isDragging = true;
    startX = e.clientX;
    dragStartTime = Date.now();
    track.classList.add('dragging');
  });
  window.addEventListener('mouseup', function(e) {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('dragging');
    const dx = e.clientX - startX;
    const dt = Date.now() - dragStartTime;
    const vw = document.querySelector('.slider-outer').offsetWidth;
    const velocity = Math.abs(dx) / dt;
    const threshold = vw * 0.25;
    if (Math.abs(dx) > threshold || (velocity > 0.4 && Math.abs(dx) > 30)) {
      goTo(dx < 0 ? current + 1 : current - 1);
    }
  });
  window.addEventListener('mouseleave', function() {
    isDragging = false;
    track.classList.remove('dragging');
  });

  // Touch swipe
  let touchStartX = 0, touchStartY = 0, touchStartTime = 0, isTouchSliding = false;
  track.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchStartTime = Date.now();
    isTouchSliding = false;
  }, { passive: true });
  track.addEventListener('touchmove', function(e) {
    const dx = Math.abs(e.touches[0].clientX - touchStartX);
    const dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (!isTouchSliding && dy > dx * 1.5) return;
    isTouchSliding = true;
  }, { passive: true });
  track.addEventListener('touchend', function(e) {
    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;
    const dt = Date.now() - touchStartTime;
    const vw = document.querySelector('.slider-outer').offsetWidth;
    const velocity = Math.abs(dx) / dt;
    const threshold = vw * 0.25;
    if (Math.abs(dy) > Math.abs(dx) * 1.5) return;
    if (Math.abs(dx) > threshold || (velocity > 0.4 && Math.abs(dx) > 30)) {
      goTo(dx < 0 ? current + 1 : current - 1);
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowRight') goTo(current + 1);
    if (e.key === 'ArrowLeft') goTo(current - 1);
  });
})();

/* ---- script block: HOTSPOT touch toggle + hover delay ---- */
(() => {
  const hs = document.querySelectorAll('.hotspot');
  const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  if (isTouchDevice()) {
    hs.forEach(h => {
      let hideTimer = null;
      const card = h.querySelector('.hotspot__card');

      h.addEventListener('click', e => {
        e.stopPropagation();
        clearTimeout(hideTimer);
        const was = h.classList.contains('is-active');
        hs.forEach(x => { if (x !== h) x.classList.remove('is-active'); });
        if (!was) h.classList.add('is-active');
      });

      // カード自体のタップ・タッチでも消えないように維持（MA1/DS1と同じ感度に統一）
      if (card) {
        card.addEventListener('click', e => { e.stopPropagation(); clearTimeout(hideTimer); });
        card.addEventListener('touchstart', e => { e.stopPropagation(); clearTimeout(hideTimer); }, { passive: true });
      }
    });

    document.addEventListener('click', () => {
      hs.forEach(x => x.classList.remove('is-active'));
    });
    return;
  }

  /* Desktop: hover with delay for easy card access */
  hs.forEach(h => {
    let hideTimer = null;
    const show = () => { clearTimeout(hideTimer); h.classList.add('is-active'); };
    const hide = () => { hideTimer = setTimeout(() => { h.classList.remove('is-active'); }, 400); };
    h.addEventListener('mouseenter', show);
    h.addEventListener('mouseleave', hide);
    const card = h.querySelector('.hotspot__card');
    if (card) {
      card.addEventListener('mouseenter', show);
      card.addEventListener('mouseleave', hide);
    }
  });
})();

/* ---- script block: HOTSPOT SP座標適用 ---- */
/* data-sp-left / data-sp-top を持つ .hotspot を、SP幅（<=768px）では
   その座標に、PC幅ではインラインstyleの元座標に切り替える。 */
(() => {
  const targets = document.querySelectorAll('.hotspot[data-sp-left]');
  if (!targets.length) return;
  const mq = window.matchMedia('(max-width: 768px)');

  targets.forEach((el) => {
    el.dataset.pcLeft = el.style.left;
    el.dataset.pcTop = el.style.top;
  });

  const apply = () => {
    targets.forEach((el) => {
      if (mq.matches) {
        el.style.left = el.dataset.spLeft;
        el.style.top = el.dataset.spTop;
      } else {
        el.style.left = el.dataset.pcLeft;
        el.style.top = el.dataset.pcTop;
      }
    });
  };

  apply();
  mq.addEventListener('change', apply);
})();

/* ---- script block: GLOBAL HEADER 表示制御（HERO通過で表示） ---- */
/*
  PCヘッダー(.g-header)とSPヘッダー(.sp_pagemap_header)を、
  HEROセクションが画面外へ出たタイミングで表示（スライドイン）、
  HERO内では非表示（is-hidden）に戻す。BALMUDA sp_pagemap_header と同挙動。
*/
(() => {
  const hero    = document.getElementById('hero-section');
  const pcHeader = document.getElementById('global-header');
  const spHeader = document.getElementById('spHeader');
  if (!hero) return;

  const setHidden = (hidden) => {
    if (pcHeader) pcHeader.classList.toggle('is-hidden', hidden);
    if (spHeader) spHeader.classList.toggle('is-hidden', hidden);
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        /* HEROがほぼ画面外（10%未満表示）になったら表示 */
        setHidden(en.isIntersecting && en.intersectionRatio > 0.1);
      });
    }, { threshold: [0, 0.1, 0.5, 1] });
    io.observe(hero);
  } else {
    /* フォールバック：スクロール量で判定 */
    const onScroll = () => setHidden(window.scrollY < hero.offsetHeight * 0.9);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

/* ---- script block: SP DRAWER メニュー開閉 ---- */
(() => {
  const toggle  = document.getElementById('toggle_btn');
  const drawer  = document.getElementById('spDrawer');
  const overlay = document.getElementById('spDrawerOverlay');
  const closeBtn = document.getElementById('spDrawerClose');
  if (!toggle || !drawer) return;

  const open = () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sp-drawer-open');
  };
  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sp-drawer-open');
  };

  toggle.addEventListener('click', open);
  if (overlay) overlay.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);
  /* メニュー内リンクタップで閉じる */
  drawer.querySelectorAll('.js-drawer-link').forEach((a) => {
    a.addEventListener('click', close);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();

/* ---- script block: js-scroll-to スムーススクロール ---- */
(() => {
  document.querySelectorAll('.js-scroll-to').forEach((a) => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

/* ---- script block: USER STORIES ---- */
/*
  1. 逆▼背景アニメーション：セクション上端通過→下端までに濃色 #cccbc8 が全高へ伸長
  2. カード浮遊アニメーション（Vermicular スタイル）
     スクロールが各カードに差し掛かった瞬間に IntersectionObserver で
     .is-visible を付与 → CSS transition translateY(60px)→0 + opacity
  3. 無限ループスライダー（高速・seamless）
     クローン戦略で端到達時に瞬時ジャンプ
     BACK / NEXT / ドラッグ / タッチ 対応
*/
(() => {
  const section  = document.getElementById('user-stories-section');
  const bgDark   = document.getElementById('usBgDark');
  const list     = document.getElementById('usSliderList');
  const btnBack  = document.getElementById('userStoriesBack');
  const btnNext  = document.getElementById('userStoriesNext');
  if (!section) return;

  /* ==============================================
     1. 逆▼背景：スクロール連動で濃色エリアを伸ばす
     ============================================== */
  if (bgDark) {
    const updateBg = () => {
      const rect = section.getBoundingClientRect();
      const secH = section.offsetHeight;
      if (rect.top > window.innerHeight) { bgDark.style.height = '0px'; return; }
      if (rect.bottom < 0)               { bgDark.style.height = secH + 'px'; return; }
      const progress = Math.min(1, Math.max(0, -rect.top / secH));
      bgDark.style.height = Math.round(progress * secH) + 'px';
    };
    let bgTick = false;
    window.addEventListener('scroll', () => {
      if (!bgTick) { requestAnimationFrame(() => { updateBg(); bgTick = false; }); bgTick = true; }
    }, { passive: true });
    updateBg();
  }

  /* ==============================================
     2. カード浮遊：スライダーが画面内に入ったら
        各カードに .is-visible を順次付与
     ============================================== */
  if (list) {
    const triggerCards = () => {
      list.querySelectorAll('.user-stories__card:not(.is-visible)').forEach(c => {
        c.classList.add('is-visible');
      });
    };
    const io = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) { triggerCards(); io.disconnect(); }
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    io.observe(section);
    /* 既にビューポート内なら即発火 */
    if (section.getBoundingClientRect().top < window.innerHeight * 0.9) triggerCards();
  }

  /* ==============================================
     3. 無限ループスライダー（完全シームレス）
        配列: [ clone_last×3 | 1 2 3 4 5 | clone_first×3 ]
        NEXT/BACKで移動 → クローン域への遷移アニメーション完了後に
        対称の実スライド位置へ瞬時ジャンプ（no-transition）
        → 次の操作は実スライドから始まるためギャップが生じない
     ============================================== */
  if (!list || !btnBack || !btnNext) return;

  const origSlides = Array.from(list.querySelectorAll('.us-slider__slide:not(.is-clone)'));
  const total      = origSlides.length;
  const CLONE      = 3; /* 前後に複製する枚数（表示枚数分確保） */

  /* 末尾クローン（先頭N枚のコピー：1 2 3） → listに追加 */
  for (let i = 0; i < CLONE; i++) {
    const cl = origSlides[i].cloneNode(true);
    cl.classList.add('is-clone');
    cl.querySelectorAll('.user-stories__card').forEach(c => {
      c.classList.add('is-visible'); c.style.transitionDelay = '0s';
    });
    list.appendChild(cl);
  }
  /* 先頭クローン（末尾N枚のコピー）→ insertBefore で先頭に追加
     i=0 → 追加: total-1 (5) → [5]
     i=1 → 追加: total-2 (4) → [4, 5]
     i=2 → 追加: total-3 (3) → [3, 4, 5]
     結果: [3 4 5 | 1 2 3 4 5 | 1 2 3] */
  for (let i = 0; i < CLONE; i++) {
    const cl = origSlides[total - 1 - i].cloneNode(true);
    cl.classList.add('is-clone');
    cl.querySelectorAll('.user-stories__card').forEach(c => {
      c.classList.add('is-visible'); c.style.transitionDelay = '0s';
    });
    list.insertBefore(cl, list.firstChild);
  }
  /* 全配列: [3 4 5 | 1 2 3 4 5 | 1 2 3] (CLONE=3なら) */
  const allSlides = Array.from(list.querySelectorAll('.us-slider__slide'));
  let cur       = CLONE;    /* 実スライド1枚目 */
  let isJumping = false;
  const slider  = list.closest('.us-slider');

  /* スライド幅 */
  const sw = () => {
    const r = allSlides[0].getBoundingClientRect();
    return r.width + (parseFloat(getComputedStyle(list).gap) || 23);
  };

  /* 位置セット */
  const setPos = (idx, anim) => {
    if (!anim) {
      list.style.transition = 'none';
      list.style.transform  = `translateX(-${idx * sw()}px)`;
      /* 強制リフロー後にtransitionを戻す */
      void list.offsetWidth;
      list.style.transition = '';
    } else {
      list.style.transform = `translateX(-${idx * sw()}px)`;
    }
  };

  /* 初期配置（アニメーションなし） */
  setPos(cur, false);

  /* transitionend: クローン域にいたら実スライドへ瞬間リセット */
  list.addEventListener('transitionend', e => {
    if (e.target !== list || isJumping) return;
    if (cur >= total + CLONE) {
      isJumping = true;
      cur -= total;
      setPos(cur, false);
      isJumping = false;
    } else if (cur < CLONE) {
      isJumping = true;
      cur += total;
      setPos(cur, false);
      isJumping = false;
    }
  });

  const next = () => { cur++; setPos(cur, true); };
  const prev = () => { cur--; setPos(cur, true); };

  btnNext.addEventListener('click', next);
  btnBack.addEventListener('click', prev);

  /* マウスドラッグ */
  let dx0 = 0, tx0 = 0, dragging = false;
  slider.addEventListener('mousedown', e => {
    dragging = true; dx0 = e.clientX; tx0 = cur * sw();
    list.style.transition = 'none';
    slider.classList.add('is-dragging');
    e.preventDefault();
  });
  window.addEventListener('mousemove', e => {
    if (!dragging) return;
    list.style.transform = `translateX(-${tx0 - (e.clientX - dx0)}px)`;
  });
  window.addEventListener('mouseup', e => {
    if (!dragging) return;
    dragging = false;
    slider.classList.remove('is-dragging');
    list.style.transition = '';
    const d = e.clientX - dx0;
    if (Math.abs(d) > 50) { d < 0 ? next() : prev(); } else { setPos(cur, true); }
  });

  /* タッチ（スワイプ）：スライダー本体のみ対象、ボタン上のタップは除外 */
  let tx = 0, ty = 0;
  slider.addEventListener('touchstart', e => {
    tx = e.touches[0].clientX;
    ty = e.touches[0].clientY;
  }, { passive: true });
  slider.addEventListener('touchend', e => {
    if (e.target.closest('.user-stories__nav-btn')) return;
    const d  = e.changedTouches[0].clientX - tx;
    const dy = Math.abs(e.changedTouches[0].clientY - ty);
    if (Math.abs(d) > 40 && dy < 60) { d < 0 ? next() : prev(); }
  }, { passive: true });

  /* BACK / NEXT ボタン
     ・click      → PC クリック
     ・touchstart → SP タップ（最速・ドラッグ開始と競合しない）
     ※ touchstart で発火させ、click の二重発火は touchstart 内で防ぐ */
  const attachBtn = (btn, fn) => {
    if (!btn) return;
    let tapped = false;
    btn.addEventListener('touchstart', e => {
      e.stopPropagation();
      tapped = true;
      fn();
    }, { passive: true });
    btn.addEventListener('click', e => {
      if (tapped) { tapped = false; return; }  /* touchstart済みならスキップ */
      fn();
    });
  };
  attachBtn(btnBack, prev);
  attachBtn(btnNext, next);

  window.addEventListener('resize', () => setPos(cur, false));
})();

/* ---- script block: SPEC もっと詳しく見る 開閉（SP collapsible） ---- */
(() => {
  const btn = document.getElementById('specMoreBtn');
  const table = document.getElementById('specCollapsibleTable');
  if (!btn || !table) return;

  const label = btn.querySelector('.wall-spec__more-btn-text');
  const OPEN_TXT = '閉じる';
  const CLOSED_TXT = 'もっと詳しく見る';

  const isOpen = () => btn.classList.contains('is-open');

  const open = () => {
    btn.classList.add('is-open');
    table.style.maxHeight = table.scrollHeight + 'px';
    if (label) label.textContent = OPEN_TXT;
    btn.setAttribute('aria-expanded', 'true');
  };
  const close = () => {
    btn.classList.remove('is-open');
    table.style.maxHeight = null;
    if (label) label.textContent = CLOSED_TXT;
    btn.setAttribute('aria-expanded', 'false');
  };
  const toggle = () => { isOpen() ? close() : open(); };

  btn.setAttribute('aria-controls', 'specCollapsibleTable');
  btn.setAttribute('aria-expanded', 'false');

  /* touch/click 二重発火ガード（既存パターン準拠） */
  let tapped = false;
  btn.addEventListener('touchstart', e => {
    e.stopPropagation();
    tapped = true;
    toggle();
  }, { passive: true });
  btn.addEventListener('click', () => {
    if (tapped) { tapped = false; return; }
    toggle();
  });

  /* 開いている状態でウィンドウ幅が変わったら実高さを再計算 */
  window.addEventListener('resize', () => {
    if (isOpen()) table.style.maxHeight = table.scrollHeight + 'px';
  });
})();

